export default __webpack_public_path__ + "static/media/element_87.70957f77.webp";